<mat-divider></mat-divider>
<footer class="grad">
    &copy;All Right Reserved 2021
</footer>